//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";

export default {
    name: "AQTreeConfigItem",
    components: {
        QAuModelPicker,
        AQInput,
        AQButton,
        AQChip
    },
    props: {
        dataItem: {
            type: Array,
            default: () => []
        },
        parentTree: {
            type: Object,
            default: () => ({})
        },
        section: {
            type: String,
            default: ""
        },
        isFromRequest: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            constraints: {},
            showVariables: null,
            changeIcon: false,
            indexToOpen: null,
            indexParent: null,
            emptyName: false,
            duplicatedName: false,
            doneBtnDisabled: false,
            customDataValue: "",
            selectTab: "dataModel",
            paramName: "",
            iconProps: {
                name: "keyboard_arrow_down"
            }
        };
    },
    computed: {
        constraint() {
            return this.isFromRequest ? { types: ["string", "date", "time", "datetime", "integer", "boolean", "decimal"] } : { types: ["string"] };
        },
        isError() {
            return this.emptyName || this.duplicatedName;
        },
        errorMsgLabel() {
            return this.duplicatedName ? this.$t("diagrams.components.configApi.customHeaderErrorValue")
                : this.$t("diagrams.components.configApi.emptyNameError");
        }
    },
    methods: {
        itemEntryIconName(value) {
            let icon = "mdi-circle-small";
            if (this.indexToOpen && value.index === this.indexToOpen) {
                icon = this.changeIcon ? "mdi-menu-down" : "mdi-menu-right";
            } else if (value.children && value.children.length) {
                icon = value.children[0].hide ? "mdi-menu-right" : "mdi-menu-down";
            }
            return icon;
        },
        resetErrorState() {
            this.duplicatedName = false;
            this.emptyName = false;
        },
        resetData() {
            this.customDataValue = "";
        },
        changeDataModel(child, parent, idx) {
            this.indexParent = idx;
            this.showVariables = child;
        },
        checkParamName() {
            if (this.paramName) {
                this.emptyName = false;
                this.duplicatedName = this.dataItem.some(elem => elem.parameterLabel === this.paramName.trim());
                this.doneBtnDisabled = this.duplicatedName;
            } else {
                this.emptyName = true;
                this.doneBtnDisabled = true;
            }
        },
        deleteConfiguration(index) {
            this.$emit("deleteCustomHeaderItem", index);
        },
        loadData(index, fromParamName) {
            if (fromParamName) {
                this.paramName = this.dataItem[index].parameterLabel;
            } else if (this.dataItem[index].paramValue) {
                if (this.dataItem[index].paramValue.startsWith("m_") || this.dataItem[index].paramValue.startsWith("s_")) {
                    this.customDataValue = "";
                    this.selectTab = "dataModel";
                } else {
                    this.customDataValue = this.dataItem[index].paramValue;
                    this.selectTab = "customData";
                }
            }
        },
        refreshMenu(index) {
            setTimeout(() => {
                this.$refs[`popoverValueRef${index}`][0].updatePosition();
            }, 0);
        },
        okEvent(index, fromParamName) {
            if (fromParamName) {
                this.$refs.popoverRef[index].hide();
            } else {
                this.$refs[`popoverValueRef${index}`][0].hide();
            }
            this.$emit("insertParamName", { index, paramName: fromParamName ? this.paramName.trim() : this.customDataValue.trim(), fromParamName });
            this.paramName = "";
            this.customDataValue = "";
            this.selectTab = "dataModel";
        },
        cancelEvent(index, fromParamName) {
            if (fromParamName) {
                this.$refs.popoverRef[index].hide();
            } else {
                this.customDataValue = "";
                this.selectTab = "dataModel";
                this.$refs[`popoverValueRef${index}`][0].hide();
            }
        },
        getChipType(paramValue) {
            let typeToReturn = "default";
            if (paramValue) {
                if (paramValue.startsWith("m_")) {
                    typeToReturn = "m_datamodel";
                } else if (paramValue.startsWith("s_")) {
                    typeToReturn = "s_datamodel";
                } else {
                    typeToReturn = "user";
                }
            }
            return typeToReturn;
        },
        onModelSelect(modelSelect, index) {
            if (modelSelect) {
                this.dirty = true;
                this.showVariables.paramValue = this.showVariables.paramValue === modelSelect.model ? "" : modelSelect.model;
                this.saveEnable = true;
                this.$root.$emit("sendRequestResponse");
                this.$refs[`popoverValueRef${index}`][0].hide();
            }
        }
    }
};
